const ITEMS = ["taxi near me", "taxi asap", "book a taxi now", "reliable sydney taxi service"];

export const Marquee = () => (
  <div
    data-testid="keyword-marquee"
    className="relative border-y border-gold-400/15 bg-ink-800/50 py-5 overflow-hidden"
    aria-label="Sydney taxi search phrases"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <ul key={copy} aria-hidden={copy === 1} className="flex items-center shrink-0">
          {ITEMS.map((item, i) => (
            <li key={i} className="flex items-center">
              <span className="font-display text-xl sm:text-2xl font-bold uppercase tracking-wide text-white/90 px-8 whitespace-nowrap">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-gold-400 shrink-0" aria-hidden="true" />
            </li>
          ))}
        </ul>
      ))}
    </div>
  </div>
);
